var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgImgProfileMatch = function SvgImgProfileMatch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#img-profile-match_svg__a)",
    stroke: "#212121",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.38 10H14.76v48.27h38.62V10Z",
    fill: "#fff",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.97 14.76H10v48.27h38.62V26.4H36.97V14.76Z",
    fill: "#fff",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.62 26.4H36.97V14.76L48.62 26.4Z",
    fill: "#E5F0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.57 40.12H41.5M17.57 44.94h14.19",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.51 28.05a5.27 5.27 0 1 0-10.541.001 5.27 5.27 0 0 0 10.541-.001Z",
    fill: "#E5F0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.81 70c7.865 0 14.24-6.375 14.24-14.24 0-7.864-6.375-14.24-14.24-14.24-7.864 0-14.24 6.375-14.24 14.24S42.946 70 50.81 70Z",
    fill: "#006DFF",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.81 65.51c5.385 0 9.75-4.365 9.75-9.75s-4.365-9.75-9.75-9.75-9.75 4.365-9.75 9.75 4.365 9.75 9.75 9.75Z",
    fill: "#fff",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.81 59.51a3.75 3.75 0 1 0 0-7.5 3.75 3.75 0 0 0 0 7.5Z",
    fill: "#006DFF",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.04 55.76 15.37-15.38",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m65.54 36.79-3.57 3.57.89 3.57 3.57-3.57-.89-3.57Z",
    fill: "#fff",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m70 41.26-3.57 3.57-3.57-.9 3.57-3.57 3.57.9Z",
    fill: "#fff",
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "img-profile-match_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h80v80H0z"
  })))));
};
export default SvgImgProfileMatch;